/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const clinicPageItemsItemBookings7dMin = 0
export const clinicPageItemsItemBookings7dMax = 9007199254740991

export const clinicPageItemsItemCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicPageItemsItemErrors24hMin = 0
export const clinicPageItemsItemErrors24hMax = 9007199254740991

export const clinicPageItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicPageItemsItemPfLastHeartbeatAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicPageItemsItemUsersCountMin = 0
export const clinicPageItemsItemUsersCountMax = 9007199254740991

export const clinicPagePageMax = 9007199254740991

export const clinicPagePageSizeMax = 100

export const clinicPageTotalMin = 0
export const clinicPageTotalMax = 9007199254740991

export const ClinicPage = zod.object({
  items: zod.array(
    zod.object({
      bookings7d: zod.int().min(clinicPageItemsItemBookings7dMin).max(clinicPageItemsItemBookings7dMax),
      connection: zod.enum(['connected', 'not_connected']),
      createdAt: zod.iso.datetime({ offset: true }).regex(clinicPageItemsItemCreatedAtRegExp),
      displayStatus: zod.enum(['active', 'inactive', 'not_connected']),
      errors24h: zod.int().min(clinicPageItemsItemErrors24hMin).max(clinicPageItemsItemErrors24hMax),
      id: zod.uuid().regex(clinicPageItemsItemIdRegExp),
      name: zod.string(),
      needsAttention: zod.boolean(),
      pf: zod.object({
        degradedReason: zod.string().nullable(),
        lastHeartbeatAt: zod.union([
          zod.iso.datetime({ offset: true }).regex(clinicPageItemsItemPfLastHeartbeatAtOneRegExp),
          zod.null(),
        ]),
        pfKeeperApp: zod.enum(['up', 'degraded', 'down', 'unknown']),
        pfSession: zod.enum(['up', 'degraded', 'down', 'unknown']),
        status: zod.enum(['healthy', 'degraded', 'down', 'unknown', 'not_connected', 'inactive']),
      }),
      slug: zod.string(),
      status: zod.enum(['active', 'inactive']),
      testingIgnorePfHours: zod.boolean().optional(),
      usersCount: zod.int().min(clinicPageItemsItemUsersCountMin).max(clinicPageItemsItemUsersCountMax),
    }),
  ),
  page: zod.int().min(1).max(clinicPagePageMax),
  pageSize: zod.int().min(1).max(clinicPagePageSizeMax),
  total: zod.int().min(clinicPageTotalMin).max(clinicPageTotalMax),
})

export type ClinicPage = zod.input<typeof ClinicPage>
export type ClinicPageOutput = zod.output<typeof ClinicPage>
